import { Component, effect, inject, ViewChild } from '@angular/core';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { ServiceSettingsEprescriptionsStore } from './service-settings-eprescriptions.store';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import {
    SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-eprescription.type';
import { contentGlobalSuccess } from '../../../../content.error';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Divider } from '@openng/optimus-ui/divider';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import {
    ServiceDoctorsSecretsComponent,
} from '../../../../../../components/medical-service/service/settings/service-doctors-secrets/service-doctors-secrets.component';
import {
    ServiceCertificatesSettingsComponent,
} from '../../../../../../components/medical-service/service/settings/service-certificates-settings/service-certificates-settings.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';

@Component({
    selector: 'app-service-settings-eprescriptions',
    templateUrl: './service-settings-eprescriptions.component.html',
    styleUrl: './service-settings-eprescriptions.component.scss',
    providers: [ServiceSettingsEprescriptionsStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        TextInputComponent,
        ActionButtonsComponent,
        ServiceDoctorsSecretsComponent,
        ServiceCertificatesSettingsComponent,
        CheckInputComponent,
    ],
})
export class ServiceSettingsEPrescriptionsComponent {
    public readonly store = inject(ServiceSettingsEprescriptionsStore);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);

    @ViewChild(ServiceSettingsCommonComponent) serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({
        pzs: fb.control<string | null>(null),
        saveToMedicationOnSend: fb.control<boolean>(false),
    });

    constructor() {
        effect(() => {
            const defaultValues = this.store.eprescriptionsSettings();
            if (defaultValues) {
                this.form.patchValue({
                    pzs: defaultValues?.pzs || '',
                    saveToMedicationOnSend: defaultValues?.saveToMedicationOnSend ?? false,
                });
            }
        });
    }

    save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            ...JSON.parse(this.serviceSettingsCommonComponent.getFormData()),
            pzs: this.form.value.pzs,
            saveToMedicationOnSend: Boolean(this.form.value.saveToMedicationOnSend),
        };

        this.store.api.updateServiceSettings({
            key: SERVICE_SETTINGS_EPRESCRIPTIONS_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: Number(serviceId),
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

    protected async cancel(): Promise<void> {
        await this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }

    protected readonly Number = Number;
    protected readonly routeParams = routeParams;
    protected readonly UserSecretTypeEnum = UserSecretTypeEnum;
}
